import React, { useState } from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel,
} from "../ui/alert-dialog";
import { Textarea } from "../ui/textarea";

/** Cancelling an interview booking always requires a reason (Recruitment Deep Audit
 * requirement) - stricter than the backend, which accepts a blank reason, but this UI
 * deliberately never allows that path. */
export const CancelInterviewDialog = ({ open, onOpenChange, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (!reason.trim()) return;
    setSubmitting(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
    } catch (e) {
      // Error is already surfaced via toast by the page-level action helper - keep the
      // dialog open with the reason intact so the recruiter can retry.
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={(next) => { if (!submitting) { onOpenChange(next); if (!next) setReason(""); } }}>
      <AlertDialogContent data-testid="cancel-interview-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Interview</AlertDialogTitle>
          <AlertDialogDescription>
            This releases the protected 2-hour interview block back to the availability grid and returns the
            applicant's pipeline stage to Screening. A reason is required.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Textarea
          data-testid="cancel-interview-reason-input"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason for cancelling this interview (required)"
          rows={3}
        />
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-interview-dialog-back" disabled={submitting}>Back</AlertDialogCancel>
          <button
            data-testid="cancel-interview-dialog-confirm"
            disabled={!reason.trim() || submitting}
            onClick={handleConfirm}
            className="px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-semibold hover:bg-red-700 disabled:opacity-50"
          >
            {submitting ? "Cancelling..." : "Confirm Cancellation"}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
